import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
export const AddRoleDialogWrapper = styled(Dialog)`
  height: 100%;
  .customDialogTitle {
    background-color: #1b4a83;
    text-align: center;
    color: #fff;
  }
  .customDialog {
    text-align: center;
    color: #000;
    img {
      display: block;
      margin: 10px auto; /* Center the image horizontally */
      max-width: 100px; /* Set the desired max width for the image */
    }
    .field {
      width: 100%;
      min-height: 92px;
      .Mui-disabled {
        color: black;
        -webkit-text-fill-color: black;
      }
    }
   

    .note {
      width: 70%;
      text-align: left;
      font-weight: 700;
      padding-left: 20px;
    }
    .customDropdown {
      text-align: left;
      max-width: 100%;
      min-width: 100%;
    }
    span.error {
      color: #d32f2f;
      line-height: 2;
      font-weight: 400;
    }
    span.red {
      color: #ff0000;
      font-weight: 600;

    }
    .errorInput {
      border: 1px solid #ff0000;
      border-radius: 5px;
    }
.textfieldbg{
    background-color: rgb(228, 228, 228);
  }
    .inputform {
      display: flex;
      width: 50%;
      padding-top: 10px;
      text-align: start;
      flex-direction: column;
      align-items: start;
      .formValue {
        width: 100%;
      }
    }
  }
  .dialogbutton {
    text-align: center;
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-bottom: 10px;
    .confirmButton {
      text-transform: none;
      text-align: center;
      width: 10%;
    }
    .rightButton {
      text-align: center;
      text-transform: none;
      color: #1b4a83;
      width: 10%;
      border-color: #1b4a83;
    }
  }
  .inputformside {
    display: flex;
    width: 100%;
    padding-top: 10px;
    gap: 40px;
    text-align: start;
    flex-direction: row;
    align-items: start;
    .formValue {
      width: 100%;
    }
  }

  .error {
    color: #d32f2f;
    font-size: 12px;
    margin-top: 2px;
  }
  .css-k4qjio-MuiFormHelperText-root{
    margin-left: 0px;
  }
`;
